module.exports = "/_next/static/images/simulations-9c005d7fd5e7d8a995022755a331286d.png";